window.site = (window.site || {});

/**
 * Init AjaxPagination related scripts
 * @class Site
 * @static
 */
site.HoffmanLifeGallery = (function HoffmanLifeGallery() {
  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    const $liningText = document.querySelector('.hoffman-life-lp .hoffman-life-gallery .gallery-heading');

    if ($liningText) {
      const poemLining = lining($liningText, {
        'autoResize': true,
        'from': 2,
        'to': 3,
        'lineClass': 'my-class'
      });
    }

    return true;
  };


  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
